import type { View } from 'react-native'
import { usePositioningLayout } from '~/hooks/layout/use-positioning-layout'
import type { LayoutInfo } from '~/hooks/layout/types'

const COACHMARK_CONSTANTS = {
  LAYOUT_RECALCULATION_DELAY: 100,
  LAYOUT_TOLERANCE: 1,
} as const

interface UseCoachmarkLayoutProps {
  isOpen: boolean
}

interface UseCoachmarkLayoutReturn {
  rootLayout: LayoutInfo | null
  isLayoutReady: boolean
  rootRef: React.RefObject<View>
  handleLayout: (event: {
    nativeEvent: {
      layout: { x: number; y: number; width: number; height: number }
    }
  }) => void
}

export function useCoachmarkLayout({
  isOpen,
}: UseCoachmarkLayoutProps): UseCoachmarkLayoutReturn {
  const { layout, isLayoutReady, elementRef, handleLayoutChange } =
    usePositioningLayout({
      isActive: isOpen,
      config: {
        recalculationDelay: COACHMARK_CONSTANTS.LAYOUT_RECALCULATION_DELAY,
        tolerance: COACHMARK_CONSTANTS.LAYOUT_TOLERANCE,
      },
    })

  return {
    rootLayout: layout,
    isLayoutReady,
    rootRef: elementRef,
    handleLayout: handleLayoutChange,
  }
}
